const list = {
    "Philosophy":[
      {"title": "The Philosophy Book: Big Ideas Simply Explained",
       "rating":"4.5/5",
       "description":"What is the meaning of life? What is the Universe made of? Read what our eminent philosophers thought about the nature of reality, and the fundamental questions we ask ourselves."},
      {"title":"Ikigai: The Japanese secret to a long and happy life",
      "rating":"4.5/5",
      "description":"Japanese art of ikigai ... Its basic message is about 'authentic living'"},
      {"title":"The Republic",
       "rating":"4.5/5",
       "description":"Plato’s most popular work and has demonstrated to be one of the world's most powerful works of reasoning ,philosophy and political theory ,both mentally and verifiably. "}
    ],
    "Self Improvement":[
      {"title": "Atomic Habits: The life-changing million copy bestseller",
      "rating":"4.5/5",
      "description":"A supremely practical and useful book. James Clear distils the most fundamental information about habit formation, so you can accomplish more by focusing on less."},
      {"title": "The Power of Your Subconscious Mind",
      "rating": "4.0/5",
      "description":"As a man thinketh in his subconscious mind, so is he."},
      {"title": "Mindset",
      "rating": "4.5/5",
      "description":"Dweck explains why it's not just our abilities and talent that bring us success-but whether we approach them with a fixed or growth mindset."}
    ],
    "Web-development":[
      {"title": "Eloquent Javascript",
      "rating":"4.5/5",
      "description":"JavaScript lies at the heart of almost every modern web application, from social apps like Twitter to browser-based game frameworks like Phaser and Babylon."},
      {"title":"The Principles Of Object-oriented Javascript ",
      "rating":"5/5",
      "description":"JavaScript is an incredibly powerful and expressive object-oriented language that puts many design decisions right into your hands."},
      {"title":"HTML 5 and CSS 3 Made Simple",
      "rating":"3.6/5",
      "description":"An introductory book on HTML 5 and CSS"}
    ] 
  }

  export default list;